import { render, staticRenderFns } from "./GroupsTags.vue?vue&type=template&id=bb3ede76&"
import script from "./GroupsTags.vue?vue&type=script&lang=js&"
export * from "./GroupsTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports